import { SystemLogEventLevelKinds, SystemLogInformation } from ".";
import { DomainRegistry } from "..";
import { LoggerFactory } from "../../utilities/logger";

export class SystemLogger {
  public static async error(message: string, error: Error = null, patientId: string = null): Promise<void> {
    try {
      const info = new SystemLogInformation();
      info.level = SystemLogEventLevelKinds.Error;
      info.patientId = patientId;
      info.message = message + (error ? " " + (error.stack ? error.stack : error.message) : null);

      const repo = DomainRegistry.system.getLogRepository();
      return repo.addSystemLog(info);
    } catch (e) {
      // 上位にはthrowしない
      LoggerFactory.getLogger().error(e);
    }
  }

  public static async info(message: string, patientId: string = null): Promise<void> {
    try {
      const info = new SystemLogInformation();
      info.level = SystemLogEventLevelKinds.Info;
      info.patientId = patientId;
      info.message = message;

      const repo = DomainRegistry.system.getLogRepository();
      return repo.addSystemLog(info);
    } catch (e) {
      // 上位にはthrowしない
      LoggerFactory.getLogger().error(e);
    }
  }
}
